import ModelUtil from '@leverege/model-util';
import Util from "./Util.js";
const TYPE = Util.getExportFormatterTypeForType('csv');
function create() {
  return {
    type: TYPE,
    extension: 'csv',
    separator: ','
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('separator'),
  ...ModelUtil.createAllValue('extension')
};